import { SectionAddMenuEntry } from 'src/cashflows/components/SectionAddButton';
import {
  CategoryInfo,
  financialAssetOptions,
} from 'src/financial/financial-data/hooks/useFinancialItems';

type DropdownCategory = 'ASSET' | 'LIABILITY';

// Nested products (e.g. Pension) are abstract categories, not creatable entity
// types — descend into them so the menu only ever offers concrete leaf products
// (DefinedContributionPension, etc.) that the create flow can handle.
export function getCategoryEntries(category: DropdownCategory): SectionAddMenuEntry[] {
  const categoryInfo: CategoryInfo = financialAssetOptions[category];
  return categoryInfo.productsOrder.map(product => {
    const productInfo = categoryInfo.products[product];
    if ('products' in productInfo) {
      return {
        label: productInfo.label,
        items: productInfo.productsOrder.map(leaf => ({
          value: leaf,
          label: productInfo.products[leaf].label,
        })),
      };
    }
    return { value: product, label: productInfo.label };
  });
}
